import { createEntityAdapter } from '@reduxjs/toolkit';

const adservingsAdapter = createEntityAdapter();

export default adservingsAdapter;
